<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <span v-on="on" class="font-12-m">
          <slot></slot>
        </span>
      </template>

      <div class="custom-tooltip">
        <div v-for="item in items" :key="item.color">
          <v-icon :color="item.color" size="12">lens</v-icon>
          <span class="ml-1">{{item.text}}</span>
        </div>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [{ color: "primary",text:"Ativo" }, { color: "red",text:"Inativo" }, { color: "gray",text: "Desconhecido" }],
    };
  },
};
</script>

<style scoped>
.custom-tooltip {
  font-size: 12px;
}
.custom-tooltip label {
  margin-right: 4px;
}
.cursor-default {
  cursor: default;
}
</style>
